import React from 'react';
import clsx from 'clsx';
import { Box } from '@material-ui/core';
import { ReactComponent as ArrowSVG } from './arrow.svg';
import { CardProps } from './intefrace';
import useStyles from './styles';
import AnimatedFade from '../animated-fade';

const Card = ({
  id,
  header,
  content,
  ctaLabel,
  onClick,
  onCtaClick,
  onCancel,
  baseWidth,
  height,
  cancelLabel,
  type,
  disabled,
  loading,
  statusLabel,
  wrapperClassName,
}: CardProps) => {
  const classes = useStyles({ baseWidth, disabled, height, type });
  return (
    <AnimatedFade
      id={id}
      className={clsx(
        classes.wrapper,
        type === 'booking' ? classes.hideOverlay : classes.showArrowOnHover,
        wrapperClassName,
      )}
      onClick={onClick}
      loading={loading}
    >
      <Box className={classes.card}>
        <Box className={clsx(type === 'mentor' && classes.cardHeader)}>
          {header}
        </Box>
        <Box className={classes.cardContent}>
          {content}

          {ctaLabel && !statusLabel && (
            <Box
              className={clsx(
                classes.footer,
                type === 'booking' && classes.showArrowOnHover,
              )}
              onClick={onCtaClick}
            >
              {ctaLabel} <ArrowSVG className={classes.arrow} />
            </Box>
          )}

          {cancelLabel && (
            <Box className={classes.cancel} onClick={onCancel}>
              {cancelLabel}
            </Box>
          )}
        </Box>
      </Box>

      {statusLabel}
    </AnimatedFade>
  );
};

export default Card;
